// Catálogo i18n da Classificação regional (PRD §4.9) — pt-BR (fonte: PDFs oficiais).
// 4 normas v1 MG: mgIndustry/mgMining (Decreto 48.140/2021 anexos I/II),
// mgWater (anexo III) e igam (Portaria IGAM). Textos transcritos dos quadros normativos.
export const regionalClassificationCatalogPtBR = {
  "norms": {
    "mgIndustry": "MG Decreto nº 48.140/2021 - Barragens para disposição de resíduos ou rejeitos da indústria",
    "mgMining": "MG Decreto nº 48.140/2021 - Barragens para disposição de resíduos ou rejeitos da mineração",
    "mgWater": "MG Decreto nº 48.140/2021 - Barragens para acumulação de água associados a processos industriais ou de mineração",
    "igam": "IGAM"
  },
  "mgIndustry": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Classificação de risco" },
      "pda": { "label": "PDA", "subtitle": "2 - Potencial de dano ambiental" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservação - EC",
      "psb": "1.3 - Plano de segurança da barragem - PSB",
      "pda": "2 - Classificação quanto ao potencial de dano ambiental - PDA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Comprimento",
      "ctC": "Vazão de Projeto",
      "ctD": "Método Construtivo",
      "ctE": "Auscultação",
      "ecF": "Confiabilidade das Estruturas Extravasoras",
      "ecG": "Percolação",
      "ecH": "Deformações e Recalques",
      "ecI": "Deterioração dos Taludes / Paramentos",
      "psbJ": "Documentação de Projeto",
      "psbK": "Estrutura Organizacional e Qualificação dos Profissionais na Equipe de Segurança da Barragem",
      "psbL": "Manuais de Procedimentos para Inspeções de Segurança e Monitoramento",
      "psbM": "Plano de Ação Emergencial – PAE (quando exigido pelo órgão fiscalizador)",
      "psbN": "Relatórios de inspeção e monitoramento da instrumentação e de Análise de Segurança",
      "pdaA": "Volume Total do Reservatório",
      "pdaB": "Existência de população a jusante",
      "pdaC": "Impacto ambiental",
      "pdaD": "Impacto socioeconômico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 10m",
        "score1": "10m < Altura < 30m",
        "score4": "30m ≤ Altura ≤ 60m",
        "score7": "Altura > 60m"
      },
      "ctB": {
        "score0": "Comprimento ≤ 50m",
        "score1": "50m < Comprimento < 200m",
        "score2": "200 ≤ Comprimento ≤ 600m",
        "score3": "Comprimento > 600m"
      },
      "ctC": {
        "score0": "CMP (Cheia Máxima Provável) ou Decamilenar",
        "score2": "Milenar",
        "score5": "TR = 500 anos",
        "score10": "TR inferior a 500 anos ou desconhecida / Estudo não confiável"
      },
      "ctD": {
        "score1": "Etapa única",
        "score3": "Estrutura alteada"
      },
      "ctE": {
        "score0": "Existe instrumentação de acordo com o projeto técnico ou não se aplica a utilização de método de auscultação",
        "score2": "Existe instrumentação em desacordo com o projeto, porém em processo de instalação de instrumentos para adequação ao projeto",
        "score6": "Existe instrumentação em desacordo com o projeto sem processo de instalação de instrumentos para adequação ao projeto",
        "score8": "Barragem não instrumentada em desacordo com o projeto"
      },
      "ecF": {
        "score0": "Estruturas civis bem mantidas e em operação normal / barragem sem necessidade de estruturas extravasoras",
        "score3": "Estruturas com problemas identificados e medidas corretivas em implantação",
        "score6": "Estruturas com problemas identificados e sem implantação das medidas corretivas necessárias",
        "score10": "Estruturas com problemas identificados, com redução de capacidade vertente e sem medidas corretivas"
      },
      "ecG": {
        "score0": "Percolação totalmente controlada pelo sistema de drenagem",
        "score3": "Umidade ou surgência nas áreas de jusante, paramentos, taludes e ombreiras estáveis e monitorados",
        "score6": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras sem implantação das medidas corretivas necessárias",
        "score10": "Surgência nas áreas de jusante com carreamento de material ou com vazão crescente ou infiltração do material contido, com potencial de comprometimento da segurança da estrutura"
      },
      "ecH": {
        "score0": "Não existem deformações e recalques com potencial de comprometimento da segurança da estrutura",
        "score2": "Existência de trincas e abatimentos com medidas corretivas em implantação",
        "score6": "Existência de trincas e abatimentos sem implantação das medidas corretivas necessárias",
        "score10": "Existência de trincas, abatimentos ou escorregamentos, com potencial de comprometimento da segurança da estrutura"
      },
      "ecI": {
        "score0": "Não existe deterioração de taludes e paramentos",
        "score2": "Falhas na proteção dos taludes e paramentos, presença de vegetação arbustiva",
        "score6": "Erosões superficiais, ferragem exposta, presença de vegetação arbórea, sem implantação das medidas corretivas necessárias",
        "score10": "Depressões acentuadas nos taludes, escorregamentos, sulcos profundos de erosão, com potencial de comprometimento da segurança da estrutura"
      },
      "psbJ": {
        "score0": "Projeto executivo e \"como construído\"",
        "score2": "Projeto executivo ou \"como construído\"",
        "score3": "Projeto \"como está\"",
        "score5": "Projeto básico",
        "score8": "Projeto conceitual",
        "score10": "Não há documentação de projeto"
      },
      "psbK": {
        "score0": "Possui unidade administrativa com profissional técnico qualificado responsável pela segurança da barragem",
        "score1": "Possui profissional técnico qualificado (próprio ou contratado) responsável pela segurança da barragem",
        "score3": "Possui unidade administrativa sem profissional técnico qualificado responsável pela segurança da barragem",
        "score6": "Não possui unidade administrativa e responsável técnico qualificado pela segurança da barragem"
      },
      "psbL": {
        "score0": "Possui manuais de procedimentos para inspeção, monitoramento e operação",
        "score2": "Possui apenas manual de procedimentos de monitoramento",
        "score4": "Possui apenas manual de procedimentos de inspeção",
        "score8": "Não possui manuais ou procedimentos formais para monitoramento e inspeções"
      },
      "psbM": {
        "score0": "Possui PAE",
        "score2": "Não possui PAE (não é exigido pelo órgão fiscalizador)",
        "score4": "PAE em elaboração",
        "score8": "Não possui PAE (quando for exigido pelo órgão fiscalizador)"
      },
      "psbN": {
        "score0": "Emite regularmente relatórios de inspeção e monitoramento com base na instrumentação e de Auditoria de Segurança",
        "score2": "Emite regularmente apenas relatórios de Auditoria de Segurança",
        "score4": "Emite regularmente apenas relatórios de inspeção e monitoramento",
        "score6": "Emite regularmente apenas relatórios de inspeção visual",
        "score8": "Não emite regularmente relatórios de inspeção e monitoramento e de Auditoria de Segurança"
      },
      "pdaA": {
        "score1": "Muito pequeno: ≤ 1 milhão m³",
        "score2": "Pequeno: 1 milhão a 5 milhões m³",
        "score3": "Médio: 5 milhões a 25 milhões m³",
        "score4": "Grande: 25 milhões a 50 milhões m³",
        "score5": "Muito grande: ≥ 50 milhões m³"
      },
      "pdaB": {
        "score0": "Inexistente — não existem pessoas permanentes/residentes ou temporárias/transitando na área afetada a jusante da barragem",
        "score3": "Pouco frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe estrada vicinal de uso local",
        "score5": "Frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe rodovia municipal ou estadual ou federal ou outro local e/ou empreendimento de permanência eventual de pessoas que poderão ser atingidas",
        "score10": "Existente — existem pessoas ocupando permanentemente a área afetada a jusante da barragem, portanto, vidas humanas poderão ser atingidas"
      },
      "pdaC": {
        "score0": "Insignificante — área afetada a jusante da barragem encontra-se totalmente descaracterizada de suas condições naturais e a estrutura armazena apenas resíduos Classe II, segundo a NBR 10.004 da ABNT",
        "score2": "Pouco significativo — área afetada a jusante da barragem não apresenta área de interesse ambiental relevante ou áreas protegidas em legislação específica, excluídas APPs, e armazena apenas resíduos Classe II, segundo a NBR 10.004 da ABNT",
        "score4": "Significativo — área afetada a jusante da barragem apresenta área de interesse ambiental relevante ou áreas protegidas em legislação específica, excluídas APPs, e armazena apenas resíduos Classe II, segundo a NBR 10.004 da ABNT",
        "score10": "Muito significativo — barragem armazena rejeitos ou resíduos sólidos classificados na Classe I – Perigosos, segundo a NBR 10.004 da ABNT"
      },
      "pdaD": {
        "score0": "Inexistente — não existem quaisquer instalações na área afetada a jusante da barragem",
        "score1": "Baixo — existe pequena concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico-cultural na área afetada a jusante da barragem",
        "score3": "Médio — existe moderada concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico-cultural na área afetada a jusante da barragem",
        "score5": "Alto — existe alta concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico-cultural na área afetada a jusante da barragem"
      }
    }
  },
  "mgMining": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Classificação de risco" },
      "pda": { "label": "PDA", "subtitle": "2 - Potencial de dano ambiental" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservação - EC",
      "psb": "1.3 - Plano de segurança da barragem - PSB",
      "pda": "2 - Classificação quanto ao potencial de dano ambiental - PDA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Comprimento",
      "ctC": "Vazão de Projeto",
      "ctD": "Método Construtivo",
      "ctE": "Auscultação",
      "ecF": "Confiabilidade das Estruturas Extravasoras",
      "ecG": "Percolação",
      "ecH": "Deformações e Recalques",
      "ecI": "Deterioração dos Taludes / Paramentos",
      "psbJ": "Documentação de Projeto",
      "psbK": "Estrutura Organizacional e Qualificação dos Profissionais na Equipe de Segurança da Barragem",
      "psbL": "Manuais de Procedimentos para Inspeções de Segurança e Monitoramento",
      "psbM": "Plano de Ação Emergencial – PAE (quando exigido pelo órgão fiscalizador)",
      "psbN": "Relatórios de inspeção e monitoramento da instrumentação e de Análise de Segurança",
      "pdaA": "Volume Total do Reservatório",
      "pdaB": "Existência de população a jusante",
      "pdaC": "Impacto ambiental",
      "pdaD": "Impacto socioeconômico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 10m",
        "score1": "10m < Altura < 30m",
        "score4": "30m ≤ Altura ≤ 60m",
        "score7": "Altura > 60m"
      },
      "ctB": {
        "score0": "Comprimento ≤ 50m",
        "score1": "50m < Comprimento < 200m",
        "score2": "200 ≤ Comprimento ≤ 600m",
        "score3": "Comprimento > 600m"
      },
      "ctC": {
        "score0": "CMP (Cheia Máxima Provável) ou Decamilenar",
        "score2": "Milenar",
        "score5": "TR = 500 anos",
        "score10": "TR inferior a 500 anos ou desconhecida / Estudo não confiável"
      },
      "ctD": {
        "score0": "Etapa única",
        "score2": "Alteamento a jusante",
        "score5": "Alteamento por linha de centro",
        "score10": "Alteamento a montante ou desconhecido ou que já tenha sido alteada a montante ao longo do ciclo de vida da estrutura"
      },
      "ctE": {
        "score0": "Existe instrumentação de acordo com o projeto técnico",
        "score2": "Existe instrumentação em desacordo com o projeto, porém em processo de instalação de instrumentos para adequação ao projeto",
        "score6": "Existe instrumentação em desacordo com o projeto sem processo de instalação de instrumentos para adequação ao projeto",
        "score8": "Barragem não instrumentada em desacordo com o projeto"
      },
      "ecF": {
        "score0": "Estruturas civis bem mantidas e em operação normal / barragem sem necessidade de estruturas extravasoras",
        "score3": "Estruturas com problemas identificados e medidas corretivas em implantação",
        "score6": "Estruturas com problemas identificados e sem implantação das medidas corretivas necessárias",
        "score10": "Estruturas com problemas identificados, com redução de capacidade vertente e sem medidas corretivas"
      },
      "ecG": {
        "score0": "Percolação totalmente controlada pelo sistema de drenagem",
        "score3": "Umidade ou surgência nas áreas de jusante, paramentos, taludes e ombreiras estáveis e monitorados",
        "score6": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras sem implantação das medidas corretivas necessárias",
        "score10": "Surgência nas áreas de jusante com carreamento de material ou com vazão crescente ou infiltração do material contido, com potencial de comprometimento da segurança da estrutura"
      },
      "ecH": {
        "score0": "Não existem deformações e recalques com potencial de comprometimento da segurança da estrutura",
        "score2": "Existência de trincas e abatimentos com medidas corretivas em implantação",
        "score6": "Existência de trincas e abatimentos sem implantação das medidas corretivas necessárias",
        "score10": "Existência de trincas, abatimentos ou escorregamentos, com potencial de comprometimento da segurança da estrutura"
      },
      "ecI": {
        "score0": "Não existe deterioração de taludes e paramentos",
        "score2": "Falhas na proteção dos taludes e paramentos, presença de vegetação arbustiva",
        "score6": "Erosões superficiais, ferragem exposta, presença de vegetação arbórea, sem implantação das medidas corretivas necessárias",
        "score10": "Depressões acentuadas nos taludes, escorregamentos, sulcos profundos de erosão, com potencial de comprometimento da segurança da estrutura"
      },
      "psbJ": {
        "score0": "Projeto executivo e \"como construído\"",
        "score2": "Projeto executivo ou \"como construído\"",
        "score3": "Projeto \"como está\"",
        "score5": "Projeto básico",
        "score8": "Projeto conceitual",
        "score10": "Não há documentação de projeto"
      },
      "psbK": {
        "score0": "Possui unidade administrativa com profissional técnico qualificado responsável pela segurança da barragem",
        "score1": "Possui profissional técnico qualificado (próprio ou contratado) responsável pela segurança da barragem",
        "score3": "Possui unidade administrativa sem profissional técnico qualificado responsável pela segurança da barragem",
        "score6": "Não possui unidade administrativa e responsável técnico qualificado pela segurança da barragem"
      },
      "psbL": {
        "score0": "Possui manuais de procedimentos para inspeção, monitoramento e operação",
        "score2": "Possui apenas manual de procedimentos de monitoramento",
        "score4": "Possui apenas manual de procedimentos de inspeção",
        "score8": "Não possui manuais ou procedimentos formais para monitoramento e inspeções"
      },
      "psbM": {
        "score0": "Possui PAE",
        "score2": "Não possui PAE (não é exigido pelo órgão fiscalizador)",
        "score4": "PAE em elaboração",
        "score8": "Não possui PAE (quando for exigido pelo órgão fiscalizador)"
      },
      "psbN": {
        "score0": "Emite regularmente relatórios de inspeção e monitoramento com base na instrumentação e de Análise de Segurança",
        "score2": "Emite regularmente apenas relatórios de Análise de Segurança",
        "score4": "Emite regularmente apenas relatórios de inspeção e monitoramento",
        "score6": "Emite regularmente apenas relatórios de inspeção visual",
        "score8": "Não emite regularmente relatórios de inspeção e monitoramento e de Análise de Segurança"
      },
      "pdaA": {
        "score1": "Muito pequeno: ≤ 1 milhão m³",
        "score2": "Pequeno: 1 milhão a 5 milhões m³",
        "score3": "Médio: 5 milhões a 25 milhões m³",
        "score4": "Grande: 25 milhões a 50 milhões m³",
        "score5": "Muito grande: ≥ 50 milhões m³"
      },
      "pdaB": {
        "score0": "Inexistente — não existem pessoas permanentes/residentes ou temporárias/transitando na área afetada a jusante da barragem",
        "score3": "Pouco frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe estrada vicinal de uso local",
        "score5": "Frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe rodovia municipal ou estadual ou federal ou outro local e/ou empreendimento de permanência eventual de pessoas que poderão ser atingidas",
        "score10": "Existente — existem pessoas ocupando permanentemente a área afetada a jusante da barragem, portanto, vidas humanas poderão ser atingidas"
      },
      "pdaC": {
        "score0": "Insignificante — área afetada a jusante da barragem encontra-se totalmente descaracterizada de suas condições naturais e a estrutura armazena apenas resíduos Classe II B – Inertes, segundo a NBR 10.004 da ABNT",
        "score2": "Pouco significativo — área afetada a jusante da barragem não apresenta área de interesse ambiental relevante ou áreas protegidas em legislação específica, excluídas APPs, e armazena apenas resíduos Classe II B – Inertes, segundo a NBR 10.004 da ABNT",
        "score6": "Significativo — área afetada a jusante da barragem apresenta área de interesse ambiental relevante ou áreas protegidas em legislação específica, excluídas APPs, e armazena apenas resíduos Classe II B – Inertes, segundo a NBR 10.004 da ABNT",
        "score8": "Muito significativo — barragem armazena rejeitos ou resíduos sólidos classificados na Classe II A – Não Inertes, segundo a NBR 10.004 da ABNT",
        "score10": "Muito significativo agravado — barragem armazena rejeitos ou resíduos sólidos classificados na Classe I – Perigosos, segundo a NBR 10.004 da ABNT"
      },
      "pdaD": {
        "score0": "Inexistente — não existem quaisquer instalações na área afetada a jusante da barragem",
        "score1": "Baixo — existe pequena concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico-cultural na área afetada a jusante da barragem",
        "score3": "Médio — existe moderada concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico-cultural na área afetada a jusante da barragem",
        "score5": "Alto — existe alta concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico-cultural na área afetada a jusante da barragem"
      }
    }
  },
  "mgWater": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Classificação de risco" },
      "pda": { "label": "PDA", "subtitle": "2 - Potencial de dano ambiental" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservação - EC",
      "psb": "1.3 - Plano de segurança da barragem - PSB",
      "pda": "2 - Classificação quanto ao potencial de dano ambiental - PDA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Comprimento",
      "ctC": "Tipo de Barragem quanto ao material de construção",
      "ctD": "Tipo de fundação",
      "ctE": "Idade da Barragem",
      "ctF": "Vazão de Projeto",
      "ecG": "Confiabilidade das Estruturas Extravasoras",
      "ecH": "Confiabilidade das Estruturas de Adução",
      "ecI": "Percolação",
      "ecJ": "Deformações e Recalques",
      "ecK": "Deterioração dos Taludes / Paramentos",
      "psbL": "Existência de documentação de projeto",
      "psbM": "Estrutura organizacional e qualificação técnica dos profissionais da equipe de Segurança da Barragem",
      "psbN": "Procedimentos de roteiros de inspeções de segurança e de monitoramento",
      "psbO": "Regra operacional dos dispositivos de descarga da barragem",
      "psbP": "Relatórios de inspeção de segurança com análise e interpretação",
      "pdaA": "Volume Total do Reservatório",
      "pdaB": "Potencial de perdas de vidas humanas",
      "pdaC": "Impacto ambiental",
      "pdaD": "Impacto socioeconômico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 10m",
        "score1": "10m < Altura < 30m",
        "score2": "30m ≤ Altura ≤ 60m",
        "score3": "Altura > 60m"
      },
      "ctB": {
        "score2": "Comprimento ≤ 200m",
        "score3": "Comprimento > 200m"
      },
      "ctC": {
        "score1": "Concreto convencional",
        "score2": "Alvenaria de pedra / Concreto ciclópico / Concreto rolado – CCR",
        "score3": "Terra homogênea / Enrocamento / Terra-enrocamento"
      },
      "ctD": {
        "score1": "Rocha sã",
        "score2": "Rocha alterada dura com tratamento",
        "score3": "Rocha alterada sem tratamento / Rocha alterada fraturada com tratamento",
        "score4": "Rocha alterada mole / Saprolito / Solo compacto",
        "score5": "Solo residual / aluvião"
      },
      "ctE": {
        "score1": "Entre 30 e 50 anos",
        "score2": "Entre 10 e 30 anos",
        "score3": "Entre 5 e 10 anos",
        "score4": "< 5 anos ou > 50 anos ou sem informação"
      },
      "ctF": {
        "score3": "CMP (Cheia Máxima Provável) ou Decamilenar",
        "score5": "Milenar",
        "score8": "TR = 500 anos",
        "score10": "TR < 500 anos ou desconhecida / Estudo não confiável"
      },
      "ecG": {
        "score0": "Estruturas civis e hidroeletromecânicas em pleno funcionamento / canais de aproximação ou de restituição ou vertedouro (tipo soleira livre) desobstruídos",
        "score4": "Estruturas civis e hidroeletromecânicas preparadas para a operação, mas sem fontes de suprimento de energia de emergência / canais ou vertedouro (tipo soleira livre) com erosões ou obstruções, porém sem riscos à estrutura vertente",
        "score7": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e com medidas corretivas em implantação / canais ou vertedouro (tipo soleira livre) com erosões e/ou parcialmente obstruídos, com risco de comprometimento da estrutura vertente",
        "score10": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e sem medidas corretivas / canais ou vertedouro (tipo soleira livre) obstruídos ou com estruturas danificadas"
      },
      "ecH": {
        "score0": "Estruturas civis e dispositivos hidroeletromecânicos em condições adequadas de manutenção e funcionamento",
        "score4": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e com medidas corretivas em implantação",
        "score6": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e sem medidas corretivas"
      },
      "ecI": {
        "score0": "Percolação totalmente controlada pelo sistema de drenagem",
        "score3": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras estabilizadas e/ou monitoradas",
        "score5": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras sem tratamento ou em fase de diagnóstico",
        "score8": "Surgência nas áreas de jusante, taludes ou ombreiras com carreamento de material ou com vazão crescente"
      },
      "ecJ": {
        "score0": "Inexistente",
        "score1": "Existência de trincas e abatimentos de pequena extensão e impacto nulo",
        "score5": "Existência de trincas e abatimentos de impacto considerável gerando necessidade de estudos adicionais ou monitoramento",
        "score8": "Existência de trincas, abatimentos ou escorregamentos expressivos, com potencial de comprometimento da segurança"
      },
      "ecK": {
        "score0": "Inexistente",
        "score1": "Falhas na proteção dos taludes e paramentos, presença de arbustos de pequena extensão e impacto nulo",
        "score5": "Erosões superficiais, ferragem exposta, crescimento de vegetação generalizada, gerando necessidade de monitoramento ou atuação corretiva",
        "score7": "Depressões acentuadas nos taludes, escorregamentos, sulcos profundos de erosão, com potencial de comprometimento da segurança"
      },
      "psbL": {
        "score0": "Projeto executivo e \"como construído\"",
        "score2": "Projeto executivo ou \"como construído\"",
        "score4": "Projeto básico",
        "score6": "Anteprojeto ou Projeto conceitual",
        "score8": "Inexiste documentação de projeto"
      },
      "psbM": {
        "score0": "Possui estrutura organizacional com técnico responsável pela segurança da barragem",
        "score4": "Possui técnico responsável pela segurança da barragem",
        "score8": "Não possui estrutura organizacional e responsável técnico pela segurança da barragem"
      },
      "psbN": {
        "score0": "Possui e aplica procedimentos de inspeção e monitoramento",
        "score3": "Possui e aplica apenas procedimentos de inspeção",
        "score5": "Possui e não aplica procedimentos de inspeção e monitoramento",
        "score6": "Não possui e não aplica procedimentos para monitoramento e inspeções"
      },
      "psbO": {
        "score0": "Sim ou Vertedouro tipo soleira livre",
        "score6": "Não"
      },
      "psbP": {
        "score0": "Emite regularmente os relatórios",
        "score3": "Emite os relatórios sem periodicidade",
        "score5": "Não emite os relatórios"
      },
      "pdaA": {
        "score0": "Muito pequeno: ≤ 1 milhão de m³",
        "score1": "Pequeno: 1 milhão a 5 milhões m³",
        "score2": "Médio: 5 milhões a 25 milhões m³",
        "score3": "Grande: 25 milhões a 50 milhões m³",
        "score4": "Muito grande: ≥ 50 milhões m³"
      },
      "pdaB": {
        "score0": "Inexistente — não existem pessoas permanentes/residentes ou temporárias/transitando na área afetada a jusante da barragem",
        "score4": "Pouco frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe estrada vicinal de uso local",
        "score8": "Frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe rodovia municipal, estadual, federal ou outro local e/ou empreendimento de permanência eventual de pessoas que poderão ser atingidas",
        "score12": "Existente — existem pessoas ocupando permanentemente a área afetada a jusante da barragem, portanto, vidas humanas poderão ser atingidas"
      },
      "pdaC": {
        "score1": "Pouco significativo — área afetada da barragem não representa área de interesse ambiental, áreas protegidas em legislação específica ou encontra-se totalmente descaracterizada de suas condições naturais",
        "score2": "Significativo — a área afetada inclui áreas de proteção de uso sustentável (APA, FLONA, RESEX, etc.) ou é área de interesse ambiental e encontra-se pouco descaracterizada de suas condições naturais",
        "score5": "Muito significativo — a área afetada inclui áreas de proteção integral (ESEC, PARNA, REBIO, etc.), inclusive Terras Indígenas, ou é de grande interesse ambiental em seu estado natural"
      },
      "pdaD": {
        "score0": "Inexistente — não existem quaisquer instalações e serviços de navegação na área afetada por acidente da barragem",
        "score1": "Baixo — existe de 1 a 5 instalações residenciais e comerciais, agrícolas, industriais ou infraestrutura na área afetada da barragem",
        "score3": "Médio — existem mais de 5 até 30 instalações residenciais e comerciais, agrícolas, industriais ou de infraestrutura na área afetada da barragem",
        "score8": "Alto — grande concentração de instalações residenciais e comerciais, agrícolas, industriais, de infraestrutura e serviços de lazer e turismo na área afetada da barragem ou instalações portuárias ou serviços de navegação"
      }
    }
  },
  "igam": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Classificação de risco" },
      "dpa": { "label": "DPA", "subtitle": "2 - Dano potencial associado" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservação - EC",
      "psb": "1.3 - Plano de segurança da barragem - PS",
      "dpa": "2 - Classificação quanto ao dano potencial associado - DPA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Comprimento",
      "ctC": "Tipo de Barragem quanto ao material de construção",
      "ctD": "Tipo de fundação",
      "ctE": "Idade da Barragem",
      "ctF": "Vazão de Projeto",
      "ecG": "Confiabilidade das Estruturas Extravasoras",
      "ecH": "Confiabilidade das Estruturas de Adução",
      "ecI": "Percolação",
      "ecJ": "Deformações e Recalques",
      "ecK": "Deterioração dos Taludes / Paramentos",
      "ecL": "Eclusa",
      "psbM": "Existência de documentação de projeto",
      "psbN": "Estrutura organizacional e qualificação técnica dos profissionais da equipe de Segurança da Barragem",
      "psbO": "Procedimentos de roteiros de inspeções de segurança e de monitoramento",
      "psbP": "Regra operacional dos dispositivos de descarga da barragem",
      "psbQ": "Relatórios de inspeção de segurança com análise e interpretação",
      "dpaA": "Volume Total do Reservatório",
      "dpaB": "Potencial de perdas de vidas humanas",
      "dpaC": "Impacto ambiental",
      "dpaD": "Impacto socioeconômico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 15m",
        "score1": "15m < Altura < 30m",
        "score2": "30m ≤ Altura ≤ 60m",
        "score3": "Altura > 60m"
      },
      "ctB": {
        "score2": "Comprimento ≤ 200m",
        "score3": "Comprimento > 200m"
      },
      "ctC": {
        "score1": "Concreto convencional",
        "score2": "Alvenaria de pedra / concreto ciclópico / concreto rolado – CCR",
        "score3": "Terra homogênea / enrocamento / terra-enrocamento"
      },
      "ctD": {
        "score1": "Rocha sã",
        "score2": "Rocha alterada dura com tratamento",
        "score3": "Rocha alterada sem tratamento / Rocha alterada fraturada com tratamento",
        "score4": "Rocha alterada mole / saprolito / solo compacto",
        "score5": "Solo residual / aluvião"
      },
      "ctE": {
        "score1": "Entre 30 e 50 anos",
        "score2": "Entre 10 e 30 anos",
        "score3": "Entre 5 e 10 anos",
        "score4": "< 5 anos ou > 50 anos ou sem informação"
      },
      "ctF": {
        "score3": "CMP (Cheia Máxima Provável) ou Decamilenar",
        "score5": "Milenar",
        "score8": "TR = 500 anos",
        "score10": "TR < 500 anos ou desconhecida / Estudo não confiável"
      },
      "ecG": {
        "score0": "Estruturas civis e hidroeletromecânicas em pleno funcionamento / canais de aproximação ou de restituição ou vertedouro (tipo soleira livre) desobstruídos",
        "score4": "Estruturas civis e hidroeletromecânicas preparadas para a operação, mas sem fontes de suprimento de energia de emergência / canais ou vertedouro (tipo soleira livre) com erosões ou obstruções, porém sem riscos à estrutura vertente",
        "score7": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e com medidas corretivas em implantação / canais ou vertedouro (tipo soleira livre) com erosões e/ou parcialmente obstruídos, com risco de comprometimento da estrutura vertente",
        "score10": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e sem medidas corretivas / canais ou vertedouro (tipo soleira livre) obstruídos ou com estruturas danificadas"
      },
      "ecH": {
        "score0": "Estruturas civis e dispositivos hidroeletromecânicos em condições adequadas de manutenção e funcionamento",
        "score4": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e com medidas corretivas em implantação",
        "score6": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados, com redução de capacidade de vazão e sem medidas corretivas"
      },
      "ecI": {
        "score0": "Percolação totalmente controlada pelo sistema de drenagem",
        "score3": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras estabilizadas e/ou monitoradas",
        "score5": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras sem tratamento ou em fase de diagnóstico",
        "score8": "Surgência nas áreas de jusante, taludes ou ombreiras com carreamento de material ou com vazão crescente"
      },
      "ecJ": {
        "score0": "Inexistente",
        "score1": "Existência de trincas e abatimentos de pequena extensão e impacto nulo",
        "score5": "Existência de trincas e abatimentos de impacto considerável gerando necessidade de estudos adicionais ou monitoramento",
        "score8": "Existência de trincas, abatimentos ou escorregamentos expressivos, com potencial de comprometimento da segurança"
      },
      "ecK": {
        "score0": "Inexistente",
        "score1": "Falhas na proteção dos taludes e paramentos, presença de arbustos de pequena extensão e impacto nulo",
        "score5": "Erosões superficiais, ferragem exposta, crescimento de vegetação generalizada, gerando necessidade de monitoramento ou atuação corretiva",
        "score7": "Depressões acentuadas nos taludes, escorregamentos, sulcos profundos de erosão, com potencial de comprometimento da segurança"
      },
      "ecL": {
        "score0": "Não possui eclusa",
        "score1": "Estruturas civis e hidroeletromecânicas bem mantidas e funcionando",
        "score2": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados e com medidas corretivas em implantação",
        "score4": "Estruturas civis comprometidas ou dispositivos hidroeletromecânicos com problemas identificados e sem medidas corretivas"
      },
      "psbM": {
        "score0": "Projeto executivo e \"como construído\"",
        "score2": "Projeto executivo ou \"como construído\"",
        "score4": "Projeto básico",
        "score6": "Anteprojeto ou Projeto conceitual",
        "score8": "Inexiste documentação de projeto"
      },
      "psbN": {
        "score0": "Possui estrutura organizacional com técnico responsável pela segurança da barragem",
        "score4": "Possui técnico responsável pela segurança da barragem",
        "score8": "Não possui estrutura organizacional e responsável técnico pela segurança da barragem"
      },
      "psbO": {
        "score0": "Possui e aplica procedimentos de inspeção e monitoramento",
        "score3": "Possui e aplica apenas procedimentos de inspeção",
        "score5": "Possui e não aplica procedimentos de inspeção e monitoramento",
        "score6": "Não possui e não aplica procedimentos para monitoramento e inspeções"
      },
      "psbP": {
        "score0": "Sim ou Vertedouro tipo soleira livre",
        "score6": "Não"
      },
      "psbQ": {
        "score0": "Emite regularmente os relatórios",
        "score3": "Emite os relatórios sem periodicidade",
        "score5": "Não emite os relatórios"
      },
      "dpaA": {
        "score1": "Pequeno: ≤ 5 milhões m³",
        "score2": "Médio: 5 milhões a 75 milhões m³",
        "score3": "Grande: 75 milhões a 200 milhões m³",
        "score5": "Muito grande: > 200 milhões m³"
      },
      "dpaB": {
        "score0": "Inexistente — não existem pessoas permanentes/residentes ou temporárias/transitando na área afetada a jusante da barragem",
        "score4": "Pouco frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe estrada vicinal de uso local",
        "score8": "Frequente — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe rodovia municipal, estadual, federal ou outro local e/ou empreendimento de permanência eventual de pessoas que poderão ser atingidas",
        "score12": "Existente — existem pessoas ocupando permanentemente a área afetada a jusante da barragem, portanto, vidas humanas poderão ser atingidas"
      },
      "dpaC": {
        "score1": "Pouco significativo — a área afetada da barragem não representa área de interesse ambiental, áreas protegidas em legislação específica ou encontra-se totalmente descaracterizada de suas condições naturais",
        "score2": "Significativo — a área afetada inclui áreas de proteção de uso sustentável (APA, FLONA, RESEX, etc.) ou é área de interesse ambiental e encontra-se pouco descaracterizada de suas condições naturais",
        "score5": "Muito significativo — a área afetada inclui áreas de proteção integral (ESEC, PARNA, REBIO, etc.), inclusive Terras Indígenas, ou é de grande interesse ambiental em seu estado natural"
      },
      "dpaD": {
        "score0": "Inexistente — não existem quaisquer instalações e serviços de navegação na área afetada por acidente da barragem",
        "score1": "Baixo — existem instalações residenciais e comerciais, agrícolas, industriais ou infraestrutura na área afetada da barragem",
        "score3": "Médio — existem instalações residenciais, agrícolas, industriais ou infraestrutura na área afetada da barragem",
        "score8": "Alto — existe grande concentração de instalações residenciais, agrícolas, infraestrutura e serviços de lazer e turismo na área afetada da barragem ou instalações portuárias ou serviços de navegação"
      }
    }
  }
} as const;
